import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Header from 'components/header';
import Loading from 'components/loading';
import { Box } from '@mui/material';
import ErrorBoundary from 'components/errorBoundry';

const AppLayout = () => {
  return (
    <ErrorBoundary>
      <Header />
      <Box>
        <Suspense fallback={<Loading style={{ minHeight: '100vh' }} />}>
          <Outlet />
        </Suspense>
      </Box>
    </ErrorBoundary>
  );
};

export default AppLayout;
